export enum ResultsNumConstants {
  Delay = 500,
  PageSize = 20,
  PageSizeCondensed = 200,
}
